import React, { createContext, useState } from 'react'
import { ICustomerSummary, ICustomerAccount, ICustomerAddress, ICustomerBasic, ICustomerCurrency, ICustomerFunction, ICustomerLimits, ICustomer, ICustomerNominee } from '../Models/Customer';

export interface ICustomerContext {
  customers: ICustomerSummary[], setCustomers: React.Dispatch<React.SetStateAction<ICustomerSummary[]>>,
  childCustomers: ICustomerSummary[], setChildCustomers: React.Dispatch<React.SetStateAction<ICustomerSummary[]>>,
  customerConfig: ICustomerBasic, setCustomerConfig: React.Dispatch<React.SetStateAction<ICustomerBasic>>,
  customerNominee: ICustomerNominee, setCustomerNominee: React.Dispatch<React.SetStateAction<ICustomerNominee>>,
  customerAddresses: ICustomerAddress[], setCustomerAddresses: React.Dispatch<React.SetStateAction<ICustomerAddress[]>>,
  customerAccounts: ICustomerAccount[], setCustomerAccounts: React.Dispatch<React.SetStateAction<ICustomerAccount[]>>,
  customerCurrencies: ICustomerCurrency[], setCustomerCurrencies: React.Dispatch<React.SetStateAction<ICustomerCurrency[]>>,
  customerFunctions: ICustomerFunction[], setCustomerFunctions: React.Dispatch<React.SetStateAction<ICustomerFunction[]>>,
  customerLimits: ICustomerLimits[], setCustomerLimits: React.Dispatch<React.SetStateAction<ICustomerLimits[]>>,
  mobileVerificationId:string, setMobileVerificationId:React.Dispatch<React.SetStateAction<string>>,
  populateCustomer:Function,
  resetCustomer:Function,
}

export const CustomerContext = createContext<ICustomerContext>({} as ICustomerContext)


const CustomerProvider = (props: any) => {

  const [customerConfig, setCustomerConfig] = useState<ICustomerBasic>({} as ICustomerBasic)
  const [customerNominee, setCustomerNominee] = useState<ICustomerNominee>({} as ICustomerNominee)
  const [customers, setCustomers] = useState<ICustomerSummary[]>([])
  const [childCustomers, setChildCustomers] = useState<ICustomerSummary[]>([])
  const [customerAddresses, setCustomerAddresses] = useState<ICustomerAddress[]>([])
  const [customerAccounts, setCustomerAccounts] = useState<ICustomerAccount[]>([])
  const [customerCurrencies, setCustomerCurrencies] = useState<ICustomerCurrency[]>([])
  const [customerFunctions, setCustomerFunctions] = useState<ICustomerFunction[]>([])
  const [customerLimits, setCustomerLimits] = useState<ICustomerLimits[]>([])
  const [mobileVerificationId, setMobileVerificationId] = useState('')
  
  const populateCustomer = (customer : ICustomer) => {
    setCustomerConfig(customer.basicDetails)
    setCustomerNominee(customer.nominee)
    setCustomerAddresses(customer.addresses)
    setCustomerAccounts(customer.accounts)
    setCustomerCurrencies(customer.currencies)
    setCustomerFunctions(customer.functions)
    setCustomerLimits(customer.limits)
  }

  
  const resetCustomer = (customer : ICustomer) => {
    setCustomerConfig({} as ICustomerBasic)
    setCustomerNominee({} as ICustomerNominee)
    setCustomerAddresses([])
    setCustomerAccounts([])
    setCustomerCurrencies([])
    setCustomerFunctions([])
    setCustomerLimits([])
    setCustomers([])
    setChildCustomers([])
  }


  return (
    <CustomerContext.Provider
      value={{
        customers, setCustomers,
        customerConfig, setCustomerConfig,
        customerNominee, setCustomerNominee,
        customerAddresses, setCustomerAddresses,
        customerAccounts, setCustomerAccounts,
        customerCurrencies, setCustomerCurrencies,
        customerFunctions, setCustomerFunctions,
        customerLimits, setCustomerLimits,
        mobileVerificationId, setMobileVerificationId,
        childCustomers, setChildCustomers,
        populateCustomer,
        resetCustomer
      }}>
      {props.children}
    </CustomerContext.Provider>
  )
}

export default CustomerProvider
